import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
// import { PiHandshakeDuotone } from "react-icons/pi";



import logo_vib from './../media/img/logo-vib.jpg'
import logo_bg from './../media/img/logo-bg.jpg'
import logo_single from './../media/img/logo-single.png'

import dl_single_nt_nb from './../media/img/dl_single_nt_nb.png'
import dl_vib_4 from './../media/img/dl_vib_4.jpg'
import dl_vib_1 from './../media/img/dl_vib_1.jpg'
import x_icon_d from './../media/icons/x_icon_d.png'
import tg_icon_d from './../media/icons/tg_icon_d.png'
import ig_icon_d from './../media/icons/ig_icon_d.png'

import pop_logo_line from './../media/img/logo-line-no-bg.png'
import pop_logo_intro from './../media/img/logo-intro-1.mp4'
import pop_logo_3d_nb from './../media/img/logo-3d-no-bg.png'


import bp_logo_single from './../media/img/bp-logo-single.png'
import bp_logo_bg from './../media/img/bp-logo-bg.jpg'
import check_icon from './../media/icons/check.png'

import peki_rocket from './../media/img/peki-rocket.jpg'
import ps_logo from './../media/img/ps-logo.png'
import dt_logo from './../media/img/dt-logo.png'
import { ReactComponent as BscLogo } from './../media/img/bscscan-logo.svg';

import x_icon from './../media/icons/x-icon.png'
import twitter_icon from './../media/icons/twitter-icon.jpg'
import tg from './../media/icons/tg-icon.png'
import discord_ouline from './../media/icons/discord_outline.png'
import discord_black from './../media/icons/discord-black.png'
import copy_icon from './../media/icons/copy.png'
import bsc_icon from './../media/icons/bsc_icon.png'
import meta_icon from './../media/icons/meta-icon.png'
import set_icon from './../media/icons/set-icon.png'

import discord from './../media/icons/discord.png'
import tg_icon from './../media/icons/tg.png'
import twitter from './../media/icons/twitter.png'
import mail_icon from './../media/icons/mail-icon.png'
import dex_icon from './../media/icons/dex-icon.png'

import { htws } from './../utilities/about-htw'


const Home = () => {


    const [htwCount, setHtwcount] = useState(0)



    return ( 
        <div className="">

            <section id="home" className="home">
                <div className="home-cont">
                    <div className="flex row align-center justify-center wrap">
                        <div className="home-text">
                            <div className="home-head-subhead" data-aos="fade-right" data-aos-duration="2000">
                                <h2><span>$BBPEKIINU:</span> THE BABY PEKI</h2>
                                <h3>Introducing BabyPeki, the newest addition to the Peki Token family! BabyPeki inherits the 
                                    visionary spirit of its predecessor while carving out its unique path in the crypto world.<br />
                                    1% of Marketing from BabyPeki shall be added to <a href="https://pekiinu.web.app/" target="_blank">Peki</a>
                                </h3>
                            </div>
                            
                            <div className="home-ca-cont">
                               <h3>Contract Address</h3>
                               <div className="home-ca-box">
                                    <p>0xEd5F5544428750e7031cEA18a743a615469c1654</p>
                               </div>
                            </div>
                            
                            <a href="https://pancakeswap.finance/swap?outputCurrency=0xEd5F5544428750e7031cEA18a743a615469c1654" target="_blank" className='btn-1'>
                                Buy Token Now
                            </a>
                        </div>

                        <div className="home-img">
                            <div className="home-img-flex-column flex column overflow-y-hidden">
                                <p className="home-img-by-text">Buy Now</p>
                                <img src={bp_logo_single} className="home-text-logo-ant" alt="" data-aos="zoom-in" data-aos-duration="2000" />
                                <div className="flex row align-center justify-center home-img-line-box">
                                    <div></div>
                                    <p>$BBPEKIINU</p>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="about" id="about">
                <div className="main-frame">
                    <div className="flex row wrap align-center">
                        <div className="about-text" data-aos="fade-right" data-aos-duration="2000">
                            {/* <h2>About Popeye</h2> */}
                            <h3>Introducing BabyPeki Token: The Peki Baby</h3>
                            <p>
                                At BabyPeki, we believe in the power of staking as a means of passive income generation. Our innovative staking 
                                feature allows holders to earn rewards simply by holding onto their tokens, empowering them to grow their wealth effortlessly. <br /><br />
                                But that's just the beginning. BabyPeki is committed to rewarding its holders generously, offering enticing incentives and 
                                benefits to ensure their satisfaction and loyalty. With a dedicated team driving its development and a 
                                vibrant community supporting its growth, BabyPeki is on a mission to pave the way for a brighter, more prosperous future for all its holders.
                            </p>

                            <a href="https://t.me/babypekiinu" className="about-btn flex row gap-15 justify-center align-center">
                               <span>Join The Community</span> 
                               <img src={tg_icon} alt="" />
                            </a>
                        </div>
                        <div className="about-img" data-aos="fade-left1" data-aos-duration="2000">
                            {/* <video src={pop_logo_intro} muted autoPlay loop /> */}
                            <img src={bp_logo_bg} alt="" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="tokenomics" id="tokenomics">
                <div className="main-frame">                    
                    <div className="tk-header overflow-y-hidden" data-aos="fade-right" data-aos-duration="2000">
                        <h2>Total Supply <span>200 Q</span></h2>
                        <p data-aos="fade-up" data-aos-duration="2000">
                            $BBPEKIINU is a BEP-20 governance token of the Baby Peki that will empower the community members with voting, governance, and management rights.
                        </p>
                    </div>
                    <div className="row token-table overflow-y-hidden">
                        <div className="flex-100">
                            <center>
                                <table>
                                    <tr>
                                        <th>Specification</th>
                                        <th>Detail</th>
                                    </tr>
                                    <tr>
                                        <td>Token Name:</td>
                                        <td>BABY PEKIINU</td>
                                    </tr>
                                    <tr>
                                        <td>Ticker Symbol:</td>
                                        <td>$BBPEKIINU</td>
                                    </tr>
                                    <tr>
                                        <td>Blockchain:</td>
                                        <td>Binance</td>
                                    </tr>
                                    <tr>
                                        <td>Contract Type:</td>
                                        <td>BEP-20</td>
                                    </tr>
                                    <tr>
                                        <td>Decimals:</td>
                                        <td>9</td>
                                    </tr>
                                    <tr>
                                        <td>Total Supply:</td>
                                        <td>200.000.000.000.000.000</td>
                                    </tr>
                                </table>
                            </center>
                        </div>
                    </div>
                    <div className="row tax-box">
                        <div className="tax-heading">
                            <h2>$BBPEKIINU Token Tax</h2>
                            <p>1% of Marketing from BBPekiInu shall be added to <a href="https://pekiinu.web.app/" target="_blank">PekiInu</a></p>
                        </div>
                    </div>

                    <div className="row token-table overflow-y-hidden">
                        <div className="flex-100">
                            <center>
                                <table>
                                    <tr>
                                        <th colSpan="3">Baby Peki token tax structure</th>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>BUY</td>
                                        <td>SELL</td>
                                    </tr>
                                    {/* <tr>
                                        <td>Liquidity</td>
                                        <td>1%</td>
                                        <td>1%</td>
                                    </tr> */}
                                    {/* <tr>
                                        <td>Auto Burn</td>
                                        <td>1%</td>
                                        <td>1%</td>
                                    </tr> */}
                                    {/* <tr>
                                        <td>Marketing</td>
                                        <td>4%</td>
                                        <td>4%</td>
                                    </tr> */}
                                    <tr>
                                        <td>TOTAL TAX</td>
                                        <td>7%</td>
                                        <td>7%</td>
                                    </tr>
                                </table>
                            </center>
                        </div>
                    </div>
                </div>
            </section>

            <section className="roadmap" id="roadmap">
                <div className="main-frame">
                    <div className="roadmap-header overflow-y-hidden" data-aos="fade-up" data-aos-duration="2000">
                        <h2>Learn about our path</h2>
                        <h3>The Roadmap of $BBPEKIINU</h3>
                    </div>

                    <div className="roadmap-item-cont grid grid-column-3 grid-column-gap-25 grid-row-gap-10 overflow-y-hidden">
                        <div className="rd-item" data-aos="flip-right" data-aos-duration="2000">
                            <h2>Phase 1</h2>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> <p>Create Smart Contract</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> <p>Launch $BBPEKIINU Token</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> <p>Launch Website</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> <p>BSC Trending Campaign</p>
                            </div>
                        </div>

                        <div className="rd-item" data-aos="flip-right" data-aos-duration="2000">
                            <h2>Phase 2</h2>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p>Launch "Search for Baby Peki" Campaign</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p>500-1000 Holders</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p>Partnership</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p>On-going Prizes</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p>More Partnership</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p>Marketing</p>
                            </div>
                        </div>

                        <div className="rd-item" data-aos="flip-right" data-aos-duration="2000">
                            <h2>Phase 3</h2>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p>1500 - 2000 Holders</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p>Build the strongest Community in Crypto meme space</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p>Pushing for top 500 Top Crypto Tokens by Marketcap</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p>Massive meme marketing campaign</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p>Empowering our community</p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> <p> Strengthening the BBPEKIINU ecosystem</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="eco" id="eco">
                <div className="wider-frame-percentage">
                    <div className="eco-header" data-aos="fade-up" data-aos-duration="2000">
                        <h2>Ecosystem Tokens</h2>
                    </div>

                    <div className="eco-container">
                        <div className="flex row wrap align-center">
                            <div className="eco-text" data-aos="fade-right" data-aos-duration="2000">
                                <h2>Peki Inu</h2>
                                <p className="eco-pgh">
                                    Peki Inu Token's mission is to harness the unparalleled dedication and creativity of its 
                                    predecessor communities to create a decentralized ecosystem that offers more than just 
                                    a digital currency. It aims to provide real utility. Already 10% burn, and we have an auto burn ca 
                                </p>
                                <div className="flex row justify-center align-center gap-5 copy-address-box">
                                    <img src={copy_icon} alt="" />
                                    <p>0x760539FF254A88B925fd940C8Bc01069cf76069b</p>
                                </div>
                                <div className="flex row gap-15">
                                    <a href="https://pancakeswap.finance/swap?outputCurrency=0x55d398326f99059fF775485246999027B3197955&inputCurrency=0x760539FF254A88B925fd940C8Bc01069cf76069b" 
                                        target="_blank" className='btn-1'
                                    >
                                        Buy Peki Inu
                                    </a>
                                    <a href="https://top100token.com/address/0x760539ff254a88b925fd940c8bc01069cf76069b" target="_blank" className='btn-sp'>
                                        View Chart
                                    </a>
                                </div>
                                <div className="eco-line"></div>
                                <p className="eco-list">
                                    <span>Token name</span>: Peki Inu <br />
                                    <span>Token Ticker</span>: PekiInu <br />
                                    <span>Total supply</span>: 200.000.000.000.000.000 <br />
                                    <span>Total Burned</span>: 20% <br />
                                </p>
                            </div>
                            <div className="eco-img" data-aos="fade-left" data-aos-duration="2000">
                                <img src={peki_rocket} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* <section className="partners" id="partners">
                <div className="partners-header" data-aos="fade-up" data-aos-duration="2000">
                    <h2>Our Partners</h2>
                </div>

                <div className="mid-frame">
                    <div className="flex row wrap overflow-y-hidden">
                        <a href="https://pancakeswap.finance/swap?outputCurrency=0x55d398326f99059fF775485246999027B3197955&inputCurrency=0x760539FF254A88B925fd940C8Bc01069cf76069b" 
                            target="_blank" className="partners-item flex justify-center" data-aos="fade-right" data-aos-duration="2000"
                        >
                            <img src={ps_logo} className="partners-item-img" alt="" />
                        </a>
                        <a href="https://www.dextools.io/app/en/bnb/pair-explorer/0xa93d6925f1e1243f4c06f8e1c678629c8365b8f8?t=1713098809201" target="_blank" 
                            className="partners-item flex justify-center" data-aos="fade-up" data-aos-duration="2000"
                        >
                            <img src={dt_logo} className="partners-item-img" alt="" />
                        </a>
                        <a href="https://bscscan.com/token/0x760539ff254a88b925fd940c8bc01069cf76069b" target="_blank" 
                            className="partners-item flex justify-center" data-aos="fade-left" data-aos-duration="2000"
                        >
                            <BscLogo className="partners-item-img" />
                        </a>
                    </div>
                </div>
            </section> */}

            <section className="join" id="join">
                <div className="main-frame">
                    <div className="flex">
                        <div className="flex-100 join-bg-1">
                            <div className="join-bg-2">
                                <div className="">
                                    
                                    <div className="flex row gap-10 j-icons" data-aos="fade-up" data-aos-duration="2000">
                                        <a href="" target="_blank">
                                            <img src={tg_icon} alt="" />
                                        </a>
                                        <a href="" target="_blank">
                                            <img src={twitter} alt="" />
                                        </a>
                                        <a href="" target="_blank">
                                            <img src={mail_icon} alt="" />
                                        </a>
                                    </div>
                                    <div className="join-text ">
                                        <h3 data-aos="fade-right" data-aos-duration="2000">Join our Community</h3>
                                        <p data-aos="fade-left" data-aos-duration="2000">Stay connected to Baby Peki</p>
                                        <a target="_blank" href="" className="btn-1">Join Telegram</a>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="htb" id="htb">
                <div className="main-frame">
                    <div className="htb-header" data-aos="fade-up" data-aos-duration="2000">
                        <h2>Be a Part of the $BBPEKIINU Movement</h2>
                        <h3>How to buy $BBPEKIINU</h3>
                    </div>
                    <div className="grid grid-column-2 row grid-column-gap-40 grid-row-gap-20 overflow-y-hidden">


                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={meta_icon} alt="" />
                                </div>
                                <h4>Create MetaMask Wallet and Connect</h4>
                                <p>
                                    Download Metamask or a wallet of your choice from the following list and create a wallet: <br />
                                    <a href="hhttps://www.coinbase.com/" target="_blank" className="display-inline">Coinbase Wallet</a> – Best for Beginners <br />
                                    <a href="https://metamask.io/" target="_blank" className="display-inline">MetaMask</a> – Best for Desktop <br />
                                    <a href="https://trustwallet.com/" target="_blank" className="display-inline">TrustWallet</a> – Best for Mobile <br />
                                    We recommend you confirm you are on the correct website when clicking any links or doing anything related to cryptocurrency. Do not get scammed!
                                </p>
                            </div>
                        </div>

                        <div className="htb-item" data-aos="flip-left" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={bsc_icon} alt="" />
                                </div>
                                <h4>Buy BNB</h4>
                                <p>
                                    In order to purchase $BBPEKIINU, you must have BNB. To acquire BNB, you can purchase 
                                    it from several centralized exchanges such
                                     as <a href="https://coinbase.com/">Coinbase</a>, <a href="https://binance.com/">Binance</a> and <a href="https://kucoin.com/">KuCoin</a>. 
                                    You must then send the BNB from the exchange to your wallet.
                                </p>
                            </div>
                        </div>
                        
                        <div className="htb-item" data-aos="flip-right" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={set_icon} alt="" />
                                </div>
                                <h4>Connect to PancakeSwap</h4>
                                <p>
                                    Go to Pancakeswap and connect your wallet of choice to the dApp. Paste the $BBPEKIINU 
                                    token address into the output currency if it is not already loaded.<br /><br />

                                    The contract address for $BBPEKIINU is Adddresss.
                                    Any contract addresses other than this are fake and may be a scam/honeypot. Be careful.
                                </p>
                            </div>
                        </div>

                        <div className="htb-item" data-aos="flip-left" data-aos-duration="2000">
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={bp_logo_single} alt="" />
                                </div>
                                <h4>Swap BNB to BBPEKIINU</h4>
                                <p>
                                    Now that you have an bnb wallet, you own BNB and you are connected to Pancakeswap, you 
                                    can now swap BNB to BABYPEKI. There are no taxes for swaps to and from BABYPEKI, 
                                    so you can enjoy your BABYPEKI tokens with no hidden fees!
                                </p>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

            <section className="footer" id="footer">
                <div className="main-container">
                    <div className="flex row justify-space-between align-center footer-row-box">
                        <div className="flex row gap-45" data-aos="fade-right" data-aos-duration="2000">
                            <a href="" target="_blank" className="flex align-center justify-center ft-row-icon-box">
                                <img src={x_icon_d} alt="" />
                            </a>
                            <a href="https://t.me/babypekiinu" target="_blank" className="flex align-center justify-center ft-row-icon-box">
                                <img src={tg_icon_d} alt="" />
                            </a>
                            {/* <a href="" target="_blank" className="flex align-center justify-center ft-row-icon-box">
                                <img src={ig_icon_d} alt="" />
                            </a> */}
                        </div>

                        <a 
                            data-aos="fade-left" data-aos-duration="2000"
                            href="https://pancakeswap.finance/swap?outputCurrency=0xEd5F5544428750e7031cEA18a743a615469c1654" target="_blank" className="btn-1"
                        >
                            Buy Now
                        </a>
                    </div>
                    <hr />
                    <p className="copyright">BABYPEKI copyright 2024 - All Rights Reserved</p>
                </div>
            </section>

        </div>
    );
}
 
export default Home;